import { render, staticRenderFns } from "./step0.vue?vue&type=template&id=4731b529"
import script from "./step0.vue?vue&type=script&lang=js"
export * from "./step0.vue?vue&type=script&lang=js"
import style0 from "./step0.vue?vue&type=style&index=0&id=4731b529&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports